<script>
  import { locale, languages, t, setLocale } from '../i18n';
</script>

<label class="language-selector">
  <span aria-hidden="true">◎</span>
  <select aria-label={$t('language')} value={$locale} on:change={event => setLocale(event.currentTarget.value)}>
    {#each languages as language}
      <option value={language.code} lang={language.tag}>{language.name}</option>
    {/each}
  </select>
</label>

<style>
  .language-selector { display: inline-flex; gap: 4px; align-items: center; max-width: 180px; }
  select { font: inherit; font-size: .85rem; color: inherit; background: transparent; border: 1px solid #8887; border-radius: 8px; padding: 8px 4px; min-width: 0; max-width: 148px; }
  option { background: white; color: #302a27; }
  select:focus-visible { outline: 3px solid #bd572b; outline-offset: 2px; }
  @media (max-width: 480px) { select { max-width: 108px; } }
</style>
